var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "text-center",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('title-rounded', {
    attrs: {
      "title": "보물을 선택하세요!"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "4",
      "data-aos": "fade-up",
      "data-aos-duration": "700",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 50 : 0
    }
  }, [_c('event-card', {
    attrs: {
      "image": "/images/event/hunt/event-img"
    },
    on: {
      "click": _vm.hunt
    }
  })], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "4",
      "data-aos": "fade-up",
      "data-aos-duration": "700",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 100 : 0
    }
  }, [_c('event-card', {
    attrs: {
      "image": "/images/event/hunt/event-img2"
    },
    on: {
      "click": _vm.hunt
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "4",
      "order": "2",
      "order-md": "1",
      "data-aos": "fade-up",
      "data-aos-duration": "700",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 100 : 0
    }
  }, [_c('event-card', {
    attrs: {
      "image": "/images/event/hunt/event-img3"
    },
    on: {
      "click": _vm.hunt
    }
  })], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "4",
      "order": "1",
      "order-md": "2",
      "data-aos": "fade-up",
      "data-aos-duration": "700",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 150 : 0
    }
  }, [_c('div', {
    staticClass: "mw-50 mw-md-100 mx-auto"
  }, [_c('event-card', {
    attrs: {
      "image": "/images/event/hunt/event-img4"
    },
    on: {
      "click": _vm.hunt
    }
  })], 1)]), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "6",
      "md": "4",
      "order": "3",
      "data-aos": "fade-up",
      "data-aos-duration": "700",
      "data-aos-delay": _vm.$vuetify.breakpoint.mdAndUp ? 200 : 0
    }
  }, [_c('event-card', {
    attrs: {
      "image": "/images/event/hunt/event-img5"
    },
    on: {
      "click": _vm.hunt
    }
  })], 1)], 1)], 1), _c('congratulation-dialog', {
    ref: "congratulationdialog"
  }), _c('already-dialog', {
    ref: "alreadydialog"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }